/** Match supported actions to the current outbreak, without changing its effects. */
export function outbreakActions(e: { illCount?: number; outbreakReported?: boolean; outbreakConcealed?: boolean }): { report: boolean; conceal: boolean } {
  const active = (e.illCount ?? 0) > 0;
  return { report: active && e.outbreakReported !== true, conceal: active && e.outbreakReported !== true && e.outbreakConcealed !== true };
}
